//
// Imports
//

import * as BrowserUtilities from "@donutteam/browser-utilities";
import Chart from "chart.js/auto"; // TODO: Maybe only import what is actually required, dipshit
import { DateTime } from "luxon";

import { ResponseBodySchema  } from "../../../api/routes/v6/users/joined-last-thirty-days-statistics.schemas.js";

//
// Locals
//

async function getDataAndCreateChart(apiUrl: string, canvas: HTMLCanvasElement)
{
	const response = await fetch(apiUrl + "/v6/users/joined-last-thirty-days-statistics",
		{
			credentials: "include",
		});

	const responseText = await response.text();

	const joinedLastThirtyDaysStatisticsResponseBody = ResponseBodySchema.parse(JSON.parse(responseText));

	if (!joinedLastThirtyDaysStatisticsResponseBody.success)
	{
		throw new Error(joinedLastThirtyDaysStatisticsResponseBody.errors[0]?.message ?? "Unknown error.");
	}

	// Note: This chart code is copied almost verbatim from the old management panel
	const chart = new Chart(canvas,
		{
			type: "line",
			data:
				{
					labels: joinedLastThirtyDaysStatisticsResponseBody.data.map(
						(dataPoint) =>
						{
							return DateTime.fromSeconds(dataPoint.dayStartSeconds).toLocaleString();
						}),
					datasets:
					[
						{
							label: "Total Users Joined",
							data: joinedLastThirtyDaysStatisticsResponseBody.data.map(dataPoint => dataPoint.totalUserCount),
							backgroundColor:
							[
								`rgba(99, 123, 137, 0.2)`,
							],
							borderColor:
							[
								`rgba(99, 123, 137, 1)`,
							],
							borderWidth: 1,
							tension: 0.25,
						},
						{
							label: "Total Not Verified Users",
							data: joinedLastThirtyDaysStatisticsResponseBody.data.map(dataPoint => dataPoint.notVerifiedUserCount),
							backgroundColor:
							[
								"rgba(182,73,73,0.5)",
							],
							borderColor:
							[
								"rgba(182,73,73,1)",
							],
							borderWidth: 1,
							tension: 0.25,
						},
					],
				},
			options:
			{
				animation:
				{
					duration: 0,
				},
				aspectRatio: 2.5,
			},
		});

	window.addEventListener("resize",
		() =>
		{
			// HACK: Thing won't fucking resize when scaling down the window, maybe ask Jake
			canvas.style.height = "";
			canvas.style.width = "";
			canvas.width = 0;
			canvas.height = 0;

			chart.resize();
		});
}

//
// Component
//

export function initialiseJoinedLastThirtyDaysStatisticsChart(joinedLastThirtyDaysStatisticsChart: HTMLElement)
{
	const apiUrl = BrowserUtilities.ElementClientLib.getStringDataOrThrow(joinedLastThirtyDaysStatisticsChart, "apiUrl");

	const canvas = BrowserUtilities.ElementClientLib.getElementOrThrow<HTMLCanvasElement>(joinedLastThirtyDaysStatisticsChart, "canvas");

	getDataAndCreateChart(apiUrl, canvas)
		.then(() =>
		{
			joinedLastThirtyDaysStatisticsChart.querySelector(".canvas")?.classList.add("show");
		})
		.catch((error) =>
		{
			console.error("[JoinedLastThirtyDaysStatisticsChart] Error loading:", error);

			joinedLastThirtyDaysStatisticsChart.querySelector(".loading-failed")?.classList.add("show");
		})
		.finally(() =>
		{
			joinedLastThirtyDaysStatisticsChart.querySelector(".loader")?.remove();
		});

	joinedLastThirtyDaysStatisticsChart.classList.add("initialised");
}

export function initialiseJoinedLastThirtyDaysStatisticsCharts()
{
	const joinedLastThirtyDaysStatisticsCharts = document.querySelectorAll<HTMLElement>(".component-joined-last-thirty-days-statistics-chart:not(.initialised)");

	console.log("[JoinedLastThirtyDaysStatisticsChart] Initialising " + joinedLastThirtyDaysStatisticsCharts.length + " instances...");

	for (const joinedLastThirtyDaysStatisticsChart of joinedLastThirtyDaysStatisticsCharts)
	{
		try
		{
			initialiseJoinedLastThirtyDaysStatisticsChart(joinedLastThirtyDaysStatisticsChart);
		}
		catch (error)
		{
			console.error("[JoinedLastThirtyDaysStatisticsChart] Error initialising:", joinedLastThirtyDaysStatisticsChart, error);
		}
	}
}